import 'react-sizes';
import { withSizes } from '../utilities/withSizes.js';
import { withTheme } from '@vebox/etui-system';
import '../utilities/responsive.js';
import '../utilities/omit.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { Component, createElement } from 'react';
import '../utilities/get-styleprop.js';
import { c as _defineProperty, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import '../Icon/Icon.js';
import '@vebox/etui-icons';
import '../Icon/icons.js';
import '../Icon/helper.js';
import '@vebox/etui-colors';
import '../Spinner/Spinner.js';
import '../utils-fabc7ae7.js';
import 'react-dom';
import 'react-spring/renderprops.cjs';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import '../Button/Button.js';
import '../Checkbox/CheckboxBase.js';
import '../Checkbox/CheckboxCircle.js';
import '../Checkbox/utils.js';
import '../Checkbox/Checkbox.js';
import 'element-resize-detector';
import '../ContainerDimensions/ContainerDimensions.js';
import '../Pagination/Pager.js';
import '../Pagination/Pagination.js';
import BaseTable from './BaseTable.js';
import 'rc-table';
import '../Td-2423cb3a.js';
import './createBodyRow.js';
import './createHeaderCell.js';
import './TableLoader.js';
import 'react-resizable';
import './createBodyCell.js';
import { getRowSelection } from './utils/index.js';
import Column from './Column.js';
import './SelectionBox.js';
import './SelectionCheckboxAll.js';
import './utils/get-row-key.js';
import createStore from './createStore.js';

class Table extends Component {
  constructor(props) {
    super(props);
    // eslint-disable-next-line no-return-assign
    _defineProperty(this, "setCheckboxPropsCache", cache => this.CheckboxPropsCache = cache);
    this.CheckboxPropsCache = {};
    this.store = createStore({
      selectedRowKeys: getRowSelection(props).selectedRowKeys || [],
      selectionDirty: false
    });
    props.onStoreCreated && props.onStoreCreated(this.store);
  }
  render() {
    return /*#__PURE__*/createElement(BaseTable, _extends({}, this.props, {
      store: this.store,
      checkboxPropsCache: this.CheckboxPropsCache,
      setCheckboxPropsCache: this.setCheckboxPropsCache
    }));
  }
}
_defineProperty(Table, "displayName", 'withStore(Table)');
_defineProperty(Table, "Column", Column);
const TableWithSizes = withSizes(Table);
var Table$1 = withTheme(TableWithSizes);

export default Table$1;
